export default {
  // 页面标题和导航
  'pages.electric-fee.title': '电费',
  'pages.electric-fee.subtitle': '管理小区电费账单的生成、缴费和查询',
  'pages.electric-fee.currentSelection': '当前选择：',
  'pages.electric-fee.batchImport': '批量导入',
  'pages.electric-fee.treeTitle': '楼栋楼层房屋选择',

  // 页面方法注释和错误消息
  'pages.electric-fee.loadRecentMonths.comment': '加载最近6个月的时间列表',
  'pages.electric-fee.loadRecentMonths.error': '加载最近6个月时间列表失败',
  'pages.electric-fee.setDefaultTab.comment': '只有在activeTabKey为空时才设置默认值',
  'pages.electric-fee.setDefaultTab.defaultComment': '设置默认tab',
  'pages.electric-fee.loadTreeData.comment': '加载楼栋楼层房屋树形数据',
  'pages.electric-fee.loadTreeData.error': '加载楼栋楼层房屋数据失败',
  'pages.electric-fee.expandFirstBuilding.comment': '默认展开第一个楼栋',
  'pages.electric-fee.activeTabChange.comment': '当activeTabKey首次设置后，刷新表格',
  'pages.electric-fee.treeSelect.comment': '树形选择处理',
  'pages.electric-fee.selectBuilding.comment': '选择楼栋',
  'pages.electric-fee.selectFloor.comment': '选择楼层',
  'pages.electric-fee.findBuildingName.comment': '找到楼栋名称',
  'pages.electric-fee.selectHouse.comment': '选择房屋',
  'pages.electric-fee.findBuildingFloorName.comment': '找到楼栋和楼层名称',
  'pages.electric-fee.refreshTable.comment': '刷新右侧表格',
  'pages.electric-fee.generateSubTitle.comment': '生成子标题',
  'pages.electric-fee.importSuccessCallback.comment': '导入成功回调',
  'pages.electric-fee.leftTree.comment': '左侧楼栋楼层树',
  'pages.electric-fee.rightList.comment': '右侧电费列表',
  'pages.electric-fee.batchImportModal.comment': '批量导入Modal',

  // 楼层名称拼接
  'pages.electric-fee.floorSuffix': '楼',

  // 面包屑导航
  'pages.breadcrumb.chargeManagement': '收费管理',
  'pages.breadcrumb.electricFee': '电费',

  // 表格相关
  'pages.electric-fee.table.title': '电费账单列表',
  'pages.electric-fee.table.houseInfo': '房屋信息',
  'pages.electric-fee.table.period': '账期',
  'pages.electric-fee.table.billNo': '账单编号',
  'pages.electric-fee.table.elecUsage': '用电量(kWh)',
  'pages.electric-fee.table.totalAmount': '总金额',
  'pages.electric-fee.table.paymentAmount': '缴费金额',
  'pages.electric-fee.table.dueAmount': '应缴',
  'pages.electric-fee.table.actualAmount': '实缴',
  'pages.electric-fee.table.approvalStatus': '审核状态',
  'pages.electric-fee.table.paymentStatus': '缴费状态',
  'pages.electric-fee.table.paymentTime': '缴费时间',
  'pages.electric-fee.table.dueDate': '到期日期',
  'pages.electric-fee.table.action': '操作',

  // 操作按钮
  'pages.electric-fee.action.view': '查看',
  'pages.electric-fee.action.edit': '编辑',
  'pages.electric-fee.action.delete': '删除',
  'pages.electric-fee.action.create': '新建账单',
  'pages.electric-fee.action.submitAudit': '提交审核',
  'pages.electric-fee.action.batchDelete': '批量删除',
  'pages.electric-fee.action.confirm': '确定',
  'pages.electric-fee.action.cancel': '取消',

  // 删除相关
  'pages.electric-fee.delete.confirmTitle': '确定要删除这条记录吗？',
  'pages.electric-fee.delete.success': '删除成功',
  'pages.electric-fee.delete.failure': '删除失败',
  'pages.electric-fee.batchDelete.confirmTitle': '确认删除',
  'pages.electric-fee.batchDelete.confirmMessage': '确定要删除选中的 {count} 条记录吗？',
  'pages.electric-fee.batchDelete.success': '批量删除成功',
  'pages.electric-fee.batchDelete.failure': '批量删除失败',
  'pages.electric-fee.batchDelete.noSelection': '请选择要删除的记录',
  'pages.electric-fee.batchDelete.draftOnly': '批量删除仅支持草稿状态的账单',

  // 审核相关
  'pages.electric-fee.audit.selectBillsWarning': '请选择要提交审核的账单',
  'pages.electric-fee.audit.modalTitle': '提交审核',
  'pages.electric-fee.audit.submitAudit': '提交审核',
  'pages.electric-fee.audit.auditName': '审核名称',
  'pages.electric-fee.audit.auditNamePlaceholder': '请输入审核名称',
  'pages.electric-fee.audit.auditNameRequired': '请输入审核名称',
  'pages.electric-fee.audit.submitRemark': '提交说明',
  'pages.electric-fee.audit.submitRemarkPlaceholder': '请输入提交说明（可选）',
  'pages.electric-fee.audit.selectedBillsTitle': '选中的账单列表（共 {count} 条）',
  'pages.electric-fee.audit.success': '提交审核成功',
  'pages.electric-fee.audit.failure': '提交审核失败',
  'pages.electric-fee.audit.defaultName': '{period} 电费账单 ({count}笔)',

  // 详情弹窗
  'pages.electric-fee.detail.modalTitle': '电费账单详情',
  'pages.electric-fee.detail.close': '关闭',

  // 详情字段
  'pages.electric-fee.detail.billNo': '账单编号',
  'pages.electric-fee.detail.period': '账期',
  'pages.electric-fee.detail.paymentStatus': '缴费状态',
  'pages.electric-fee.detail.approvalStatus': '审核状态',
  'pages.electric-fee.detail.startDate': '开始日期',
  'pages.electric-fee.detail.endDate': '结束日期',
  'pages.electric-fee.detail.houseInfo': '房屋信息',
  'pages.electric-fee.detail.ownerInfo': '业主信息',
  'pages.electric-fee.detail.ownerIdCard': '身份证',
  'pages.electric-fee.detail.ownerEmail': '邮箱',
  'pages.electric-fee.detail.ownerId': '业主ID',
  'pages.electric-fee.detail.lastReading': '上期读数(kWh)',
  'pages.electric-fee.detail.lastReadingDate': '上期抄表时间',
  'pages.electric-fee.detail.currentReading': '本期读数(kWh)',
  'pages.electric-fee.detail.currentReadingDate': '本期抄表时间',
  'pages.electric-fee.detail.elecUsage': '用电量',
  'pages.electric-fee.detail.unitPrice': '单价(元/kWh)',
  'pages.electric-fee.detail.baseAmount': '基础金额',
  'pages.electric-fee.detail.lateFee': '滞纳金',
  'pages.electric-fee.detail.discountAmount': '优惠金额',
  'pages.electric-fee.detail.finalAmount': '最终金额',
  'pages.electric-fee.detail.paymentMethod': '支付方式',
  'pages.electric-fee.detail.paymentReference': '支付凭证号',
  'pages.electric-fee.detail.dueDate': '到期日期',
  'pages.electric-fee.detail.paymentDate': '缴费日期',
  'pages.electric-fee.detail.createdTime': '创建时间',
  'pages.electric-fee.detail.updatedTime': '更新时间',
  'pages.electric-fee.detail.remarks': '备注',

  // 详情弹窗中的硬编码文本
  'pages.electric-fee.detail.basicInfo': '基本信息',
  'pages.electric-fee.detail.houseOwnerInfo': '房屋与业主信息',
  'pages.electric-fee.detail.meterReadingInfo': '抄表信息',
  'pages.electric-fee.detail.amountInfo': '金额信息',
  'pages.electric-fee.detail.paymentInfo': '缴费信息',
  'pages.electric-fee.detail.systemInfo': '系统信息',
  'pages.electric-fee.detail.auditRecord': '审核记录',
  'pages.electric-fee.detail.loading': '加载中...',
  'pages.electric-fee.detail.noAuditRecord': '暂无审核记录',

  // 表单相关
  'pages.electric-fee.form.editTitle': '编辑电费账单',
  'pages.electric-fee.form.createTitle': '新建电费账单',
  'pages.electric-fee.form.basicInfo': '基本信息',
  'pages.electric-fee.form.houseOwnerInfo': '房屋与业主信息',
  'pages.electric-fee.form.meterReadingInfo': '电表读数信息',
  'pages.electric-fee.form.feeInfo': '费用信息',
  'pages.electric-fee.form.remarksInfo': '备注信息',
  'pages.electric-fee.form.update': '更新',
  'pages.electric-fee.form.create': '创建',
  'pages.electric-fee.form.cancel': '取消',

  // 表单字段
  'pages.electric-fee.form.billNo': '账单编号',
  'pages.electric-fee.form.billNoPlaceholder': '请输入账单编号',
  'pages.electric-fee.form.paymentStatus': '缴费状态',
  'pages.electric-fee.form.paymentStatusPlaceholder': '请选择缴费状态',
  'pages.electric-fee.form.period': '账期',
  'pages.electric-fee.form.periodPlaceholder': '如：2024-01',
  'pages.electric-fee.form.periodRequired': '请输入账期',
  'pages.electric-fee.form.startDate': '开始日期',
  'pages.electric-fee.form.startDatePlaceholder': '请选择开始日期',
  'pages.electric-fee.form.startDateRequired': '请选择开始日期',
  'pages.electric-fee.form.endDate': '结束日期',
  'pages.electric-fee.form.endDatePlaceholder': '请选择结束日期',
  'pages.electric-fee.form.endDateRequired': '请选择结束日期',
  'pages.electric-fee.form.building': '楼栋',
  'pages.electric-fee.form.buildingPlaceholder': '请选择楼栋',
  'pages.electric-fee.form.buildingRequired': '请选择楼栋',
  'pages.electric-fee.form.floor': '楼层',
  'pages.electric-fee.form.floorPlaceholder': '请选择楼层',
  'pages.electric-fee.form.floorRequired': '请选择楼层',
  'pages.electric-fee.form.house': '房屋',
  'pages.electric-fee.form.housePlaceholder': '请选择房屋',
  'pages.electric-fee.form.houseRequired': '请选择房屋',
  'pages.electric-fee.form.lastReading': '上期读数',
  'pages.electric-fee.form.lastReadingPlaceholder': '请输入上期读数',
  'pages.electric-fee.form.lastReadingDate': '上期抄表时间',
  'pages.electric-fee.form.lastReadingDatePlaceholder': '请选择上期抄表时间',
  'pages.electric-fee.form.currentReading': '本期读数',
  'pages.electric-fee.form.currentReadingPlaceholder': '请输入本期读数',
  'pages.electric-fee.form.currentReadingRequired': '请输入本期读数',
  'pages.electric-fee.form.currentReadingDate': '本期抄表时间',
  'pages.electric-fee.form.currentReadingDatePlaceholder': '请选择本期抄表时间',
  'pages.electric-fee.form.currentReadingDateRequired': '请选择本期抄表时间',
  'pages.electric-fee.form.elecUsage': '用电量',
  'pages.electric-fee.form.elecUsageAuto': '自动计算',
  'pages.electric-fee.form.unitPrice': '单价',
  'pages.electric-fee.form.unitPricePlaceholder': '请输入单价',
  'pages.electric-fee.form.unitPriceRequired': '请输入单价',
  'pages.electric-fee.form.baseAmount': '基础金额',
  'pages.electric-fee.form.baseAmountAuto': '自动计算',
  'pages.electric-fee.form.lateFee': '滞纳金',
  'pages.electric-fee.form.lateFeePlaceholder': '请输入滞纳金',
  'pages.electric-fee.form.discountAmount': '优惠金额',
  'pages.electric-fee.form.discountAmountPlaceholder': '请输入优惠金额',
  'pages.electric-fee.form.finalAmount': '最终金额',
  'pages.electric-fee.form.finalAmountAuto': '自动计算',
  'pages.electric-fee.form.finalAmountRequired': '最终金额将自动计算',
  'pages.electric-fee.form.remarks': '备注',
  'pages.electric-fee.form.remarksPlaceholder': '请输入备注信息',
  'pages.electric-fee.form.remarksMaxLength': '备注长度不能超过500个字符',

  // 表单验证和错误消息
  'pages.electric-fee.form.serviceNotAvailable': '该房屋没有开通电费服务，请选择其他房屋',
  'pages.electric-fee.form.loadPriceConfigError': '加载电费价格配置失败',
  'pages.electric-fee.form.submitSuccess': '创建成功',
  'pages.electric-fee.form.updateSuccess': '更新成功',
  'pages.electric-fee.form.submitError': '提交失败',

  // 货币单位
  'pages.electric-fee.currency.php': '₱',

  // 分页
  'pages.electric-fee.table.pagination.showTotal': '第 {start}-{end} 条/总共 {total} 条',

  // 导入相关
  'pages.electric-fee.import.modalTitle': '批量导入电费账单',
  'pages.electric-fee.import.confirmImport': '确认导入',
  'pages.electric-fee.import.cancel': '取消',
  'pages.electric-fee.import.step1': '第一步：下载导入模板',
  'pages.electric-fee.import.downloadTemplate': '下载电费账单Excel模板',
  'pages.electric-fee.import.step2': '第二步：选择账期并上传填写好的Excel文件',
  'pages.electric-fee.import.selectPeriod': '选择账期：',
  'pages.electric-fee.import.selectPeriodPlaceholder': '请选择账期',
  'pages.electric-fee.import.uploadFile': '上传文件：',
  'pages.electric-fee.import.uploadHint': '点击或拖拽Excel文件到此区域',
  'pages.electric-fee.import.uploadFormatHint': '仅支持 .xls 和 .xlsx 格式的Excel文件，文件大小不超过10MB',
  'pages.electric-fee.import.notices': '注意事项：',
  'pages.electric-fee.import.notice1': '请先选择账期和Excel文件，然后点击"确认导入"按钮',
  'pages.electric-fee.import.notice2': '请下载模板，按照模板格式填写数据',
  'pages.electric-fee.import.notice3': '必填字段不能为空',
  'pages.electric-fee.import.notice4': '日期格式请按照模板中的示例填写',
  'pages.electric-fee.import.notice5': '导入前请检查数据的准确性',
  'pages.electric-fee.import.notice6': '如果某一行数据异常，将不会导入该数据',
  'pages.electric-fee.import.notice7': '如果数据已存在，将不会导入该数据',
  'pages.electric-fee.import.notice8': '导入数据较多时可能处理较慢，请耐心等待',
  'pages.electric-fee.import.successTitle': '导入请求已提交',
  'pages.electric-fee.import.successMessage': '数据正在导入中，请稍后刷新页面查看导入结果！',
  'pages.electric-fee.import.selectPeriodFirst': '请先选择账期！',
  'pages.electric-fee.import.selectFileFirst': '请先选择要上传的Excel文件！',
  'pages.electric-fee.import.invalidFile': '文件无效，请重新选择！',
  'pages.electric-fee.import.importFailed': '导入失败，请检查文件格式',
  'pages.electric-fee.import.downloadSuccess': '模板下载成功',
  'pages.electric-fee.import.downloadFailed': '模板下载失败',
  'pages.electric-fee.import.downloadFormatError': '下载的文件格式不正确',
  'pages.electric-fee.import.downloadEmptyError': '下载的文件为空',
  'pages.electric-fee.import.fileSizeError': '文件大小不能超过10MB!',
  'pages.electric-fee.import.templateFileName': '电费账单模板_{timestamp}.xlsx',

  // 账期查询弹窗
  'pages.electric-fee.period.modalTitle': '房间查询 - {houseName} - 账期 {period}',
  'pages.electric-fee.period.noData': '暂无数据',
  'pages.electric-fee.period.elecUsage': '用电量',
  'pages.electric-fee.period.currentMonthUsage': '本月用电量',
  'pages.electric-fee.period.currentMonthAmount': '本月应缴金额',
  'pages.electric-fee.period.avgUsage': '平均用电度数',
  'pages.electric-fee.period.currentMonthPrice': '本月单价',
  'pages.electric-fee.period.usageChange': '环比增减',
  'pages.electric-fee.period.vsLastMonth': '较上月',
  'pages.electric-fee.period.noComparisonData': '无可比数据',
  'pages.electric-fee.period.amountChange': '金额比增减',
  'pages.electric-fee.period.vsLastMonthAmount': '较上月应缴',
  'pages.electric-fee.period.avgPrice': '平均单价',
  'pages.electric-fee.period.pricePerKwh': '每度（含服务费）',
  'pages.electric-fee.period.usageTrendTitle': '近6个月用电量趋势',
  'pages.electric-fee.period.amountTrendTitle': '近6个月应缴金额趋势',
  'pages.electric-fee.period.detailTableTitle': '月度详细数据',
  'pages.electric-fee.period.month': '月份',
  'pages.electric-fee.period.unitPrice': '单价(元/kWh)',
  'pages.electric-fee.period.amount': '应缴金额(元)',
  'pages.electric-fee.period.lateFee': '滞纳金(元)',
  'pages.electric-fee.period.discountAmount': '优惠金额(元)',
  'pages.electric-fee.period.finalAmount': '最终金额(元)',
  'pages.electric-fee.period.status': '状态',

  // 状态相关
  'pages.electric-fee.status.unpaid': '未缴费',
  'pages.electric-fee.status.paid': '已缴费',
  'pages.electric-fee.status.overdue': '逾期',
  'pages.electric-fee.status.partial': '部分缴费',
  'pages.electric-fee.status.cancelled': '已取消',

  // 审核状态
  'pages.electric-fee.approvalStatus.draft': '草稿',
  'pages.electric-fee.approvalStatus.pending': '待审核',
  'pages.electric-fee.approvalStatus.approved': '已通过',
  'pages.electric-fee.approvalStatus.rejected': '已拒绝',
  'pages.electric-fee.approvalStatus.notified': '已通知',
  'pages.electric-fee.approvalStatus.overdue': '逾期',
  'pages.electric-fee.approvalStatus.cancelled': '已取消',

  // 单位
  'pages.electric-fee.unit.kwh': 'kWh',
  'pages.electric-fee.unit.phpPerKwh': '₱/kWh',

  // Detail组件字段
  'pages.electric-fee.detail.basicInfo': '基本信息',
  'pages.electric-fee.detail.billNo': '账单编号',
  'pages.electric-fee.detail.period': '账期',
  'pages.electric-fee.detail.paymentStatus': '缴费状态',
  'pages.electric-fee.detail.approvalStatus': '审核状态',
  'pages.electric-fee.detail.startDate': '开始日期',
  'pages.electric-fee.detail.endDate': '结束日期',
  'pages.electric-fee.detail.houseOwnerInfo': '房屋与业主信息',
  'pages.electric-fee.detail.houseInfo': '房屋信息',
  'pages.electric-fee.detail.ownerInfo': '业主信息',
  'pages.electric-fee.detail.meterReadingInfo': '抄表信息',
  'pages.electric-fee.detail.lastReading': '上期读数',
  'pages.electric-fee.detail.lastReadingDate': '上期抄表时间',
  'pages.electric-fee.detail.currentReading': '本期读数',
  'pages.electric-fee.detail.currentReadingDate': '本期抄表时间',
  'pages.electric-fee.detail.elecUsage': '用电量',
  'pages.electric-fee.detail.unitPrice': '单价',
  'pages.electric-fee.detail.amountInfo': '金额信息',
  'pages.electric-fee.detail.baseAmount': '基础金额',
  'pages.electric-fee.detail.lateFee': '滞纳金',
  'pages.electric-fee.detail.discountAmount': '优惠金额',
  'pages.electric-fee.detail.finalAmount': '最终金额',
  'pages.electric-fee.detail.paymentInfo': '缴费信息',
  'pages.electric-fee.detail.paymentMethod': '支付方式',
  'pages.electric-fee.detail.paymentReference': '支付凭证号',
  'pages.electric-fee.detail.dueDate': '到期日期',
  'pages.electric-fee.detail.paymentDate': '缴费日期',
  'pages.electric-fee.detail.systemInfo': '系统信息',
  'pages.electric-fee.detail.createdTime': '创建时间',
  'pages.electric-fee.detail.updatedTime': '更新时间',
  'pages.electric-fee.detail.remarks': '备注',
};
